<template>
  <div class="burgerholder" @click="togglemenu">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="burgersvg"
      viewBox="0 0 60 60"
    >
      <g class="gsvg" :class="{ hide: menuopen }">
        <path
          class="burgerstroke"
          :class="{ altmida: menuopen }"
          d="M5 15 L 55 15"
        />
        <path
          class="burgerstroke"
          :class="{ altmida: menuopen }"
          d="M5 30 L 55 30"
        />
        <path
          class="burgerstroke"
          :class="{ altmidb: menuopen }"
          d="M5 30 L 55 30"
        />
        <path
          class="burgerstroke"
          :class="{ altmidb: menuopen }"
          d="M5 45 L 55 45"
        />
      </g>
      <g class="gsvg" :class="{ hide: !menuopen }">
        <path
          class="burgerstroke"
          :class="{ top: !menuopen }"
          d="M10 10 L 50 50"
        />
        <path
          class="burgerstroke"
          :class="{ mida: !menuopen }"
          d="M10 10 L 50 50"
        />
        <path
          class="burgerstroke"
          :class="{ midb: !menuopen }"
          d="M10 50 L 50 10"
        />
        <path
          class="burgerstroke"
          :class="{ bot: !menuopen }"
          d="M10 50 L 50 10"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Burger",
  props: ["menuopen"],

  methods: {
    togglemenu: function () {
      this.$emit("togglemenu");
    },
  },
};
</script>

<style>
.burgersvg {
  width: 15vmin;
  height: 15vmin;
  max-width: 7vh;
  max-height: 7vh;
}
.burgerholder {
  padding: 1vh;
  cursor: pointer;
}
.burgerstroke {
  fill: none;
  /* stroke: white; */
  stroke-width: 6.5;
  transition: d 0.25s ease-in-out;
  stroke-opacity: 100%;
}

.top {
  d: path("M5 15 L 55 15");
}
.mida {
  d: path("M5 30 L 55 30");
}
.midb {
  d: path("M5 30 L 55 30");
}
.bot {
  d: path("M5 45 L 55 45");
}
.gsvg {
  transition: all 0.25s 0s ease-in-out;
}
.hide {
  opacity: 0;
}
.altmida {
  d: path("M10 10 L 50 50");
}
.altmidb {
  d: path("M10 50 L 50 10");
}
</style>
